<template>
  <div class="d-flex text-center justify-center align-center fullscreen">
    <slot>
      <SfiAppLoading :title="title" />

      <Suspense>
        <div>
          <router-view v-slot="{ Component }">
            <component :is="Component" />
          </router-view>
        </div>
      </Suspense>
    </slot>
  </div>
</template>

<script setup lang="ts">
const title = import.meta.env.VITE_APP_TITLE
</script>
